<!-- Navigation -->
<nav
  class="fixed top-0 left-0 right-0 z-50 bg-background/95 dark:bg-slate-900/20 backdrop-blur-sm border-b border-border/40">
  <div class="max-w-6xl mx-auto px-6 lg:px-8">
    <div class="flex justify-between items-center h-16">
      <!-- Logo -->
      <div class="flex items-center space-x-2">
        <div
          class="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center shadow-lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="h-4 w-4 icon icon-tabler icons-tabler-filled icon-tabler-location text-white">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
              d="M20.891 2.006l.106 -.006l.13 .008l.09 .016l.123 .035l.107 .046l.1 .057l.09 .067l.082 .075l.052 .059l.082 .116l.052 .096c.047 .1 .077 .206 .09 .316l.005 .106c0 .075 -.008 .149 -.024 .22l-.035 .123l-6.532 18.077a1.55 1.55 0 0 1 -1.409 .903a1.547 1.547 0 0 1 -1.329 -.747l-.065 -.127l-3.352 -6.702l-6.67 -3.336a1.55 1.55 0 0 1 -.898 -1.259l-.006 -.149c0 -.56 .301 -1.072 .841 -1.37l.14 -.07l18.017 -6.506l.106 -.03l.108 -.018z" />
          </svg>
        </div>
        <span
          class="text-xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
          >B2B CRM</span
        >
      </div>

      <!-- Navigation Links -->
      <div class="hidden md:flex items-center space-x-8">
        <a
          href="#features"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >Features</a
        >
        <a
          href="#pricing"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >Pricing</a
        >
        <a
          href="/about"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >About</a
        >
        <a
          href="/contact"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >Contact</a
        >
      </div>

      <!-- Auth Links & Theme Toggle -->
      <div class="hidden md:flex items-center space-x-4">
        <app-theme-toggle
          (themeChange)="onThemeChange($event)"></app-theme-toggle>
        <a
          href="/auth/sign-in"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >Sign In</a
        >
        <a
          href="/auth/sign-up"
          class="bg-foreground text-background px-4 py-2 rounded-md text-sm font-medium hover:bg-foreground/90 transition-colors"
          >Get Started</a
        >
      </div>

      <!-- Mobile Menu Button -->
      <div class="md:hidden flex items-center space-x-2">
        <app-theme-toggle
          (themeChange)="onThemeChange($event)"></app-theme-toggle>
        <button
          class="p-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
          (click)="toggleMobileMenu()">
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</nav>

<!-- Mobile Menu -->
<div
  class="md:hidden fixed inset-0 z-40 bg-background/95 backdrop-blur-sm transition-opacity duration-300"
  [class.opacity-0]="!isMobileMenuOpen"
  [class.opacity-100]="isMobileMenuOpen"
  [class.pointer-events-none]="!isMobileMenuOpen"
  [class.pointer-events-auto]="isMobileMenuOpen"
  *ngIf="isMobileMenuOpen">
  <div class="flex flex-col h-full pt-16">
    <div class="flex-1 px-6 py-8 space-y-8">
      <!-- Mobile Navigation Links -->
      <div class="space-y-6">
        <a
          href="#features"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >Features</a
        >
        <a
          href="#pricing"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >Pricing</a
        >
        <a
          href="/about"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >About</a
        >
        <a
          href="/contact"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >Contact</a
        >
      </div>

      <!-- Mobile Auth Links -->
      <div class="space-y-4 pt-8 border-t border-border">
        <a
          href="/auth/sign-in"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >Sign In</a
        >
        <a
          href="/auth/sign-up"
          class="block bg-foreground text-background px-6 py-3 rounded-lg text-lg font-medium hover:bg-foreground/90 transition-colors text-center"
          (click)="toggleMobileMenu()"
          >Get Started</a
        >
      </div>
    </div>
  </div>
</div>

<particles [quantity]="200">
  <section
    class="bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 dark:from-slate-900 dark:via-blue-900/20 dark:to-purple-900/20">
    <!-- Hero Section -->
    <section class="pt-24 pb-12 px-6 lg:px-8">
      <div class="max-w-4xl mx-auto text-center">
        <div class="hero-content space-y-8">
          <div class="space-y-4">
            <div
              class="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 text-sm font-medium">
              <svg
                class="w-4 h-4 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              Next-generation B2B CRM
            </div>
            <h1
              class="text-5xl md:text-6xl lg:text-7xl font-light text-foreground leading-tight tracking-tight">
              The next-gen
              <br />
              <span
                class="font-medium bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 bg-clip-text text-transparent"
                >CRM platform</span
              >
            </h1>
          </div>
          <p
            class="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Transform your B2B sales process with intelligent automation,
            advanced analytics, and seamless integrations. Built for modern
            sales teams that demand results.
          </p>
          <div
            class="relative pt-4 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/auth/sign-up"
              class="inline-flex items-center bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-4 rounded-lg text-base font-medium hover:from-blue-600 hover:to-purple-700 transition-all shadow-lg hover:shadow-xl">
              Start Free Trial
              <svg
                class="ml-2 w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7" />
              </svg>
            </a>
            <a
              href="#pricing"
              class="inline-flex items-center bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 px-8 py-4 rounded-lg text-base font-medium border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 transition-all shadow-lg">
              View Pricing
              <svg
                class="ml-2 w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2" />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 3v3m0 12v3" />
              </svg>
            </a>
          </div>
          <div
            class="pt-8 flex justify-center items-center space-x-8 text-sm text-muted-foreground">
            <div class="flex items-center space-x-2">
              <svg
                class="w-4 h-4 text-green-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
              <span>14-day free trial</span>
            </div>
            <div class="flex items-center space-x-2">
              <svg
                class="w-4 h-4 text-green-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
              <span>No credit card required</span>
            </div>
            <div class="flex items-center space-x-2">
              <svg
                class="w-4 h-4 text-green-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
              <span>Setup in 5 minutes</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Main Dashboard Preview -->
    <section class="py-16 px-6 lg:px-8">
      <div class="md:max-w-6xl xl:max-w-7xl mx-auto">
        <div class="relative">
          <div
            class="absolute transitiona-all duration-1000 opacity-70 -inset-px bg-gradient-to-r from-[#44BCFF] via-[#FF44EC] to-[#FF675E] rounded-xl blur-[100px] group-hover:opacity-100 group-hover:-inset-1 group-hover:duration-200 animate-tilt"></div>
          <!-- Main Dashboard Card -->
          <border-beam>
            <div
              class="rounded-2xl shadow-2xl border border-border overflow-hidden">
              <!-- <div class="bg-gradient-to-r from-accent/5 to-primary/5 px-6 py-4 border-b border-border">
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-4">
                    <div class="flex space-x-2">
                      <div class="w-3 h-3 bg-red-500 rounded-full"></div>
                      <div class="w-3 h-3 bg-yellow-500 rounded-full"></div>
                      <div class="w-3 h-3 bg-green-500 rounded-full"></div>
                    </div>
                    <span class="text-sm text-muted-foreground">Dashboard</span>
                  </div>
                  <div class="text-xs text-muted-foreground">B2B CRM</div>
                </div>
              </div> -->

              <!-- Dashboard Content -->
              <div class="">
                <div
                  class="rounded-lg overflow-hidden relative group cursor-pointer"
                  (click)="openVideoModal()">
                  <img
                    alt="B2B CRM Dashboard - Companies View showing Nova Techset Ltd with company listings including Havells India Ltd, Adobe Inc, Airbnb, Apple, Meta, Google, Anthropic, Stripe, Figma, and Notion with their respective websites, LinkedIn profiles, addresses, employee counts, and annual revenue"
                    class="banner-image dark:banner-image-dark w-full h-auto object-cover rounded-lg border border-border/20 transition-all duration-300 group-hover:brightness-75"
                    loading="lazy" />

                  <!-- Video Play Button Overlay -->
                  <div
                    class="absolute inset-0 flex items-center justify-center">
                    <div class="relative">
                      <!-- Pulse Effect -->
                      <div
                        class="absolute inset-0 bg-white/20 rounded-full animate-ping"></div>
                      <div
                        class="absolute inset-0 bg-white/10 rounded-full animate-ping animation-delay-75"></div>

                      <!-- Play Button -->
                      <div
                        class="relative bg-indigo-600/10 dark:bg-indigo-300/10 backdrop-blur-md rounded-full p-4 shadow-lg">
                        <div class="bg-background rounded-full p-3 shadow-lg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-play size-6 text-indigo-600 dark:text-indigo-400 fill-indigo-600 dark:fill-indigo-400 ml-0.5"
                            aria-hidden="true">
                            <polygon points="6 3 20 12 6 21 6 3"></polygon>
                          </svg>
                        </div>
                      </div>
                      <!-- <div class="relative bg-white/90 backdrop-blur-sm rounded-full p-6 shadow-2xl transform transition-all duration-300 group-hover:scale-110 group-hover:bg-white">
                        <svg class="w-8 h-8 text-blue-600 ml-1" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z"/>
                        </svg>
                      </div> -->
                    </div>
                  </div>

                  <!-- Video Badge -->
                  <div
                    class="absolute top-4 left-4 bg-black/70 backdrop-blur-sm text-white px-3 py-1 rounded-full text-sm font-medium flex items-center space-x-2">
                    <svg
                      class="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 24 24">
                      <path
                        d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                    </svg>
                    <span>Watch Demo</span>
                  </div>

                  <!-- Duration Badge -->
                  <div
                    class="absolute bottom-4 right-4 bg-black/70 backdrop-blur-sm text-white px-2 py-1 rounded text-xs font-medium">
                    2:30
                  </div>
                </div>
              </div>

              <!-- Video Modal -->
              <div
                class="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 transition-opacity duration-300"
                [class.opacity-0]="!isVideoModalOpen"
                [class.opacity-100]="isVideoModalOpen"
                [class.pointer-events-none]="!isVideoModalOpen"
                [class.pointer-events-auto]="isVideoModalOpen"
                *ngIf="isVideoModalOpen"
                (click)="closeVideoModal()">
                <div
                  class="relative max-w-4xl w-full"
                  (click)="$event.stopPropagation()">
                  <!-- Close Button -->
                  <button
                    class="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors z-10"
                    (click)="closeVideoModal()">
                    <svg
                      class="w-8 h-8"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>

                  <!-- Video Container -->
                  <div
                    class="relative bg-black rounded-lg overflow-hidden shadow-2xl">
                    <div class="aspect-video">
                      <iframe
                        *ngIf="isVideoModalOpen"
                        class="w-full h-full"
                        src="https://www.youtube.com/embed/"
                        title="B2B CRM Demo Video"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen>
                      </iframe>
                    </div>
                  </div>

                  <!-- Video Title -->
                  <div class="text-center mt-4">
                    <h3 class="text-xl font-semibold text-white mb-2">
                      B2B CRM Platform Demo
                    </h3>
                    <p class="text-gray-300">
                      See how our CRM streamlines your B2B sales process
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </border-beam>
        </div>
      </div>
      <div
        class="pointer-events-none absolute inset-x-0 -bottom-12 h-1/3 bg-gradient-to-t from-background via-background to-transparent lg:h-1/4"></div>
    </section>
  </section>
</particles>
<!-- Trusted By Section -->
<section class="py-16 px-6 lg:px-8 bg-background border-b border-border/40">
  <div class="max-w-7xl mx-auto">
    <div class="text-center mb-12">
      <p
        class="text-sm text-muted-foreground font-medium tracking-wide uppercase">
        Trusted by leading teams at
      </p>
    </div>

    <!-- Marquee Container -->
    <div class="relative overflow-hidden">
      <!-- Gradient Overlays -->
      <div
        class="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent z-10"></div>
      <div
        class="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent z-10"></div>

      <!-- Scrolling Logos -->
      <div class="flex animate-marquee space-x-16 items-center py-8">
        <!-- First Set -->
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <img
              src="assets/images/google-logo.svg"
              alt="Google"
              class="h-8 w-auto object-contain grayscale hover:grayscale-0 transition-all" />
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Google</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <img
              src="assets/images/amazon.png"
              alt="Amazon"
              class="h-8 w-auto object-contain grayscale hover:grayscale-0 transition-all" />
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Amazon</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-orange-500 to-pink-500 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">S</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Stripe</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">F</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Figma</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-red-500 to-pink-600 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">A</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Airbnb</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-gray-800 to-gray-600 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">A</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Adobe</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">N</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Notion</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">M</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Meta</span
            >
          </div>
        </div>

        <!-- Duplicate Set for Seamless Loop -->
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <img
            src="assets/images/google-logo.svg"
            alt="Google"
            class="h-8 w-auto object-contain grayscale hover:grayscale-0 transition-all" />
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <img
            src="assets/images/amazon.png"
            alt="Amazon"
            class="h-8 w-auto object-contain grayscale hover:grayscale-0 transition-all" />
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-orange-500 to-pink-500 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">S</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Stripe</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">F</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Figma</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-red-500 to-pink-600 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">A</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Airbnb</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-gray-800 to-gray-600 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">A</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Adobe</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">N</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Notion</span
            >
          </div>
        </div>
        <div
          class="flex items-center justify-center min-w-[160px] h-12 opacity-60 hover:opacity-100 transition-opacity">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">M</span>
            </div>
            <span class="font-semibold text-gray-700 dark:text-gray-300"
              >Meta</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Additional Stats -->
    <div class="mt-12 text-center">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
        <div class="space-y-2">
          <p class="text-2xl font-bold text-foreground">10,000+</p>
          <p class="text-sm text-muted-foreground">Active Users</p>
        </div>
        <div class="space-y-2">
          <p class="text-2xl font-bold text-foreground">500M+</p>
          <p class="text-sm text-muted-foreground">Contacts Managed</p>
        </div>
        <div class="space-y-2">
          <p class="text-2xl font-bold text-foreground">99.9%</p>
          <p class="text-sm text-muted-foreground">Uptime</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Feature Sections -->
<section
  class="py-20 px-6 lg:px-8 bg-background bg-gradient-to-br from-blue-50/50 to-purple-50/50 dark:from-blue-950/30 dark:to-purple-950/30"
  id="features">
  <div class="max-w-7xl mx-auto">
    <div class="text-center mb-16">
      <h2
        class="text-4xl md:text-5xl font-light text-foreground mb-6 leading-tight">
        Powerful CRM Features to Grow Your Business
      </h2>
      <p
        class="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
        Our CRM platform is built to help your sales, marketing, and operations
        teams work smarter, close deals faster, and deliver exceptional customer
        experiences. From capturing leads to closing deals, we’ve got you
        covered.
      </p>
    </div>

    <div class="grid md:grid-cols-3 gap-8">
      <!-- Home -->
      <magic-card [isDarkTheme]="isDarkTheme" [className]="'h-full'">
        <div>
          <div class="mb-6">
            <span
              class="inline-flex items-center text-xs font-medium px-3 py-1 rounded-full bg-accent/20 text-foreground/80"
              >Home</span
            >
          </div>
          <div class="space-y-4">
            <div class="flex items-start space-x-3">
              <div class="text-2xl">
                <img
                  src="assets/images/dashboard-icon.png"
                  alt="Dashboard"
                  class="min-w-8 min-h-8" />
              </div>
              <div>
                <h3 class="font-medium text-foreground">Dashboard</h3>
                <p class="text-sm text-muted-foreground">
                  Get a bird’s-eye view with real-time insights. Track sales
                  performance, monitor activities, and measure progress—all in
                  one place.
                </p>
              </div>
            </div>
          </div>
        </div>
      </magic-card>
      <!-- Records Management -->
      <magic-card [isDarkTheme]="isDarkTheme" [className]="'h-full'">
        <div>
          <div class="mb-6">
            <span
              class="inline-flex items-center text-xs font-medium px-3 py-1 rounded-full bg-accent/20 text-foreground/80"
              >Records Management</span
            >
          </div>
          <div class="space-y-4">
            <div class="flex items-start space-x-3">
              <div class="text-2xl">
                <img
                  src="assets/images/contact-icon.png"
                  alt="Contacts"
                  class="min-w-8 min-h-8" />
              </div>
              <div>
                <h3 class="font-medium text-foreground">Contacts</h3>
                <p class="text-sm text-muted-foreground">
                  Store, manage, and track every interaction with your prospects
                  and customers. Never lose a lead again.
                </p>
              </div>
            </div>
            <div class="flex items-start space-x-3">
              <div class="text-2xl">
                <img
                  src="assets/images/building-icon.png"
                  alt="Companies"
                  class="min-w-8 min-h-8" />
              </div>
              <div>
                <h3 class="font-medium text-foreground">Companies</h3>
                <p class="text-sm text-muted-foreground">
                  Organize and manage company profiles linked to your contacts
                  for a complete relationship history.
                </p>
              </div>
            </div>
            <div class="flex items-start space-x-3">
              <div class="text-2xl">
                <img
                  src="assets/images/target-icon.png"
                  alt="Leads"
                  class="min-w-8 min-h-8" />
              </div>
              <div>
                <h3 class="font-medium text-foreground">Leads</h3>
                <p class="text-sm text-muted-foreground">
                  Capture and qualify leads with ease. Assign ownership, track
                  progress, and focus on the hottest opportunities.
                </p>
              </div>
            </div>
            <div class="flex items-start space-x-3">
              <div class="text-2xl">
                <img
                  src="assets/images/thunderbolt-icon.png"
                  alt="Deals"
                  class="min-w-8 min-h-8" />
              </div>
              <div>
                <h3 class="font-medium text-foreground">Deals</h3>
                <p class="text-sm text-muted-foreground">
                  Visualize your sales pipeline, manage opportunities, and keep
                  deals moving towards closure.
                </p>
              </div>
            </div>
            <div class="flex items-start space-x-3">
              <div class="text-2xl">
                <img
                  src="assets/images/checkbox-icon.png"
                  alt="Tasks"
                  class="min-w-8 min-h-8" />
              </div>
              <div>
                <h3 class="font-medium text-foreground">Tasks</h3>
                <p class="text-sm text-muted-foreground">
                  Assign, track, and manage tasks to keep your team on schedule
                  and accountable.
                </p>
              </div>
            </div>
            <div class="flex items-start space-x-3">
              <div class="text-2xl">
                <img
                  src="assets/images/microsoft-onenote-icon.png"
                  alt="Notes"
                  class="min-w-8 min-h-8" />
              </div>
              <div>
                <h3 class="font-medium text-foreground">Notes</h3>
                <p class="text-sm text-muted-foreground">
                  Keep important details at your fingertips. Add notes to
                  contacts, deals, and tasks for seamless collaboration.
                </p>
              </div>
            </div>
          </div>
        </div>
      </magic-card>

      <!-- Engagement Tools -->
      <magic-card [isDarkTheme]="isDarkTheme" [className]="'h-full'">
        <div>
          <div class="mb-6">
            <span
              class="inline-flex items-center text-xs font-medium px-3 py-1 rounded-full bg-accent/20 text-foreground/80"
              >Engagement Tools</span
            >
          </div>
          <div class="space-y-4">
            <div class="flex items-start space-x-3">
              <div class="text-2xl">
                <img
                  src="assets/images/mailing-icon.png"
                  alt="Email Sequences"
                  class="min-w-8 min-h-8" />
              </div>
              <div>
                <h3 class="font-medium text-foreground">Email Sequences</h3>
                <p class="text-sm text-muted-foreground">
                  Automate personalized follow-ups with multi-step email
                  campaigns that keep leads warm.
                </p>
              </div>
            </div>
            <div class="flex items-start space-x-3">
              <div class="text-2xl">
                <img
                  src="assets/images/envelope-icon.png"
                  alt="Email Templates"
                  class="min-w-8 min-h-8" />
              </div>
              <div>
                <h3 class="font-medium text-foreground">Email Templates</h3>
                <p class="text-sm text-muted-foreground">
                  Save time and maintain consistency with reusable templates for
                  every stage of your sales cycle.
                </p>
              </div>
            </div>
            <div class="flex items-start space-x-3">
              <div class="text-2xl">
                <img
                  src="assets/images/ringer-volume-icon.png"
                  alt="Call Logs"
                  class="min-w-8 min-h-8" />
              </div>
              <div>
                <h3 class="font-medium text-foreground">Call Logs</h3>
                <p class="text-sm text-muted-foreground">
                  Record and track call details to keep your communication
                  history complete.
                </p>
              </div>
            </div>
            <div class="flex items-start space-x-3">
              <div class="text-2xl">
                <img
                  src="assets/images/google-forms-icon.png"
                  alt="FormsIQ"
                  class="min-w-8 min-h-8" />
              </div>
              <div>
                <h3 class="font-medium text-foreground">FormsIQ</h3>
                <p class="text-sm text-muted-foreground">
                  Create and share forms to collect lead data, feedback, or
                  survey responses directly into your CRM.
                </p>
              </div>
            </div>
          </div>
        </div>
      </magic-card>
    </div>
  </div>
</section>

<!-- Planned Features / Roadmap -->
<section
  class="py-20 px-6 lg:px-8 bg-card border border-border p-8"
  id="roadmap">
  <div class="max-w-7xl mx-auto">
    <div class="text-center mb-12">
      <h3
        class="text-3xl md:text-4xl font-light text-foreground mb-4 leading-tight">
        Planned Features / Roadmap
      </h3>
      <p
        class="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
        We’re constantly innovating to bring more power to your sales toolkit.
        Upcoming features include:
      </p>
    </div>
    <div class="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
      <magic-card [isDarkTheme]="isDarkTheme" [className]="'h-full'">
        <div>
          <div class="flex items-start space-x-4">
            <div class="text-3xl">
              <img
                src="assets/images/outgoing-call-icon.png"
                alt="Calling Integration"
                class="min-w-8 min-h-8" />
            </div>
            <div>
              <h4 class="text-xl font-semibold text-foreground mb-2">
                Calling Integration
              </h4>
              <p class="text-muted-foreground">
                Make and receive calls directly from within the CRM. Log
                conversations automatically, access call recordings, and enable
                click-to-call for faster outreach.
              </p>
            </div>
          </div>
        </div>
      </magic-card>
      <magic-card [isDarkTheme]="isDarkTheme" [className]="'h-full'">
        <div>
          <div class="flex items-start space-x-4">
            <div class="text-3xl">
              <img
                src="assets/images/calendar-icon.png"
                alt="Calendar Integration"
                class="min-w-8 min-h-8" />
            </div>
            <div>
              <h4 class="text-xl font-semibold text-foreground mb-2">
                Calendar Integration
              </h4>
              <p class="text-muted-foreground">
                Sync tasks, follow-ups, and appointments with Google Calendar,
                Outlook, and more. Stay on top of meetings and deadlines with
                real-time updates.
              </p>
            </div>
          </div>
        </div>
      </magic-card>
    </div>
  </div>
</section>

<!-- Customer Testimonials Section -->
<section
  class="py-20 px-6 lg:px-8 dark:shadow-background bg-gradient-to-br from-blue-50/50 to-purple-50/50 dark:from-blue-950/30 dark:to-purple-950/30">
  <div class="max-w-7xl mx-auto">
    <div
      id="testimonials"
      class="flex flex-col items-center my-10 scroll-mt-12">
      <div
        class="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 text-sm font-medium">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-book-user size-4.5 stroke-blue-600"
          aria-hidden="true">
          <path d="M15 13a3 3 0 1 0-6 0"></path>
          <path
            d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"></path>
          <circle cx="12" cy="8" r="2"></circle>
        </svg>
        <span>Testimonials</span>
      </div>
      <div class="text-center mt-6 text-slate-700">
        <h2 class="text-3xl sm:text-4xl font-medium text-foreground">
          Don't just take our words
        </h2>
        <p class="max-sm max-w-2xl mt-4 text-muted-foreground">
          Hear what our users say about us. We're always looking for ways to
          improve. If you have a positive experience with us, leave a review.
        </p>
      </div>
    </div>

    <div class="marquee-row w-full mx-auto max-w-5xl overflow-hidden relative">
      <div
        class="absolute left-0 top-0 h-full w-20 z-10 pointer-events-none bg-gradient-to-r from-blue-50/50 to-transparent dark:from-blue-950/30"></div>
      <div
        class="marquee-inner flex transform-gpu min-w-[200%] pt-10 pb-5"
        id="row1"></div>
      <div
        class="absolute right-0 top-0 h-full w-20 md:w-40 z-10 pointer-events-none bg-gradient-to-l from-blue-50/50 to-transparent dark:from-blue-950/30"></div>
    </div>

    <div class="marquee-row w-full mx-auto max-w-5xl overflow-hidden relative">
      <div
        class="absolute left-0 top-0 h-full w-20 z-10 pointer-events-none bg-gradient-to-r from-blue-50/50 to-transparent dark:from-blue-950/30"></div>
      <div
        class="marquee-inner marquee-reverse flex transform-gpu min-w-[200%] pt-5 pb-10"
        id="row2"></div>
      <div
        class="absolute right-0 top-0 h-full w-20 md:w-40 z-10 pointer-events-none bg-gradient-to-l from-blue-50/50 to-transparent dark:from-blue-950/30"></div>
    </div>

    <!-- Overall Stats -->
    <div class="mt-16 text-center">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
        <div class="space-y-2">
          <p class="text-3xl font-bold text-foreground">4.9/5</p>
          <p class="text-sm text-muted-foreground">Average Rating</p>
        </div>
        <div class="space-y-2">
          <p class="text-3xl font-bold text-foreground">2,500+</p>
          <p class="text-sm text-muted-foreground">Customer Reviews</p>
        </div>
        <div class="space-y-2">
          <p class="text-3xl font-bold text-foreground">98%</p>
          <p class="text-sm text-muted-foreground">Customer Satisfaction</p>
        </div>
        <div class="space-y-2">
          <p class="text-3xl font-bold text-foreground">95%</p>
          <p class="text-sm text-muted-foreground">Would Recommend</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Pricing Section -->
<section
  id="pricing"
  class="dark:shadow-background py-20 px-6 lg:px-8 bg-gradient-to-br from-slate-50 to-blue-50 dark:from-slate-900 dark:to-slate-800">
  <div class="max-w-7xl mx-auto">
    <div class="text-center mb-16">
      <h2
        class="text-4xl md:text-5xl font-light text-foreground mb-6 leading-tight">
        Choose the perfect
        <br />
        <span
          class="font-medium bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
          >plan for your business</span
        >
      </h2>
      <p
        class="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
        Start free and scale as you grow. All plans include our core CRM
        features with flexible pricing.
      </p>
    </div>

    <div class="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
      <!-- Starter Plan -->
      <div
        class="bg-card rounded-2xl border border-border p-8 shadow-lg hover:shadow-xl transition-shadow">
        <div class="text-center mb-8">
          <h3 class="text-2xl font-semibold text-foreground mb-2">Starter</h3>
          <p class="text-muted-foreground mb-6">
            Perfect for small teams getting started
          </p>
          <div class="mb-6">
            <span class="text-4xl font-bold text-foreground">$19</span>
            <span class="text-muted-foreground">/month</span>
          </div>
          <p class="text-sm text-muted-foreground">Up to 3 users</p>
        </div>

        <div class="space-y-4 mb-8">
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-green-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground">1,000 contacts</span>
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-green-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground"
              >Basic pipeline management</span
            >
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-green-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground">Email integration</span>
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-green-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground">Mobile app access</span>
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-green-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground">Basic reporting</span>
          </div>
        </div>

        <a
          href="/auth/sign-up"
          class="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white py-3 px-6 rounded-lg font-medium hover:from-blue-600 hover:to-purple-700 transition-all shadow-lg hover:shadow-xl block text-center">
          Start Free Trial
        </a>
      </div>

      <!-- Professional Plan -->
      <div
        class="bg-card rounded-2xl border-2 border-blue-500 p-8 shadow-xl hover:shadow-2xl transition-shadow relative">
        <div class="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span
            class="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 py-1 rounded-full text-sm font-medium"
            >Most Popular</span
          >
        </div>

        <div class="text-center mb-8">
          <h3 class="text-2xl font-semibold text-foreground mb-2">
            Professional
          </h3>
          <p class="text-muted-foreground mb-6">
            For growing businesses and teams
          </p>
          <div class="mb-6">
            <span class="text-4xl font-bold text-foreground">$49</span>
            <span class="text-muted-foreground">/month</span>
          </div>
          <p class="text-sm text-muted-foreground">Up to 10 users</p>
        </div>

        <div class="space-y-4 mb-8">
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-blue-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground">10,000 contacts</span>
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-blue-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground"
              >Advanced pipeline & automation</span
            >
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-blue-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground"
              >Email sequences & templates</span
            >
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-blue-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground"
              >Custom fields & workflows</span
            >
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-blue-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground"
              >Advanced analytics & reports</span
            >
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-blue-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground">API access</span>
          </div>
        </div>

        <a
          href="/auth/sign-up"
          class="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white py-3 px-6 rounded-lg font-medium hover:from-blue-600 hover:to-purple-700 transition-all shadow-lg hover:shadow-xl block text-center">
          Start Free Trial
        </a>
      </div>

      <!-- Enterprise Plan -->
      <div
        class="bg-card rounded-2xl border border-border p-8 shadow-lg hover:shadow-xl transition-shadow">
        <div class="text-center mb-8">
          <h3 class="text-2xl font-semibold text-foreground mb-2">
            Enterprise
          </h3>
          <p class="text-muted-foreground mb-6">
            For large organizations with complex needs
          </p>
          <div class="mb-6">
            <span class="text-4xl font-bold text-foreground">$99</span>
            <span class="text-muted-foreground">/month</span>
          </div>
          <p class="text-sm text-muted-foreground">Unlimited users</p>
        </div>

        <div class="space-y-4 mb-8">
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-purple-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-purple-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground">Unlimited contacts</span>
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-purple-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-purple-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground"
              >Advanced security & compliance</span
            >
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-purple-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-purple-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground">Custom integrations</span>
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-purple-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-purple-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground"
              >Dedicated account manager</span
            >
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-purple-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-purple-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground">24/7 priority support</span>
          </div>
          <div class="flex items-center space-x-3">
            <div
              class="w-5 h-5 bg-purple-100 rounded-full flex items-center justify-center">
              <svg
                class="w-3 h-3 text-purple-600"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <span class="text-sm text-foreground"
              >Custom training & onboarding</span
            >
          </div>
        </div>

        <a
          href="#contact"
          class="w-full bg-gradient-to-r from-purple-500 to-pink-600 text-white py-3 px-6 rounded-lg font-medium hover:from-purple-600 hover:to-pink-700 transition-all shadow-lg hover:shadow-xl block text-center">
          Contact Sales
        </a>
      </div>
    </div>

    <div class="text-center mt-12">
      <p class="text-muted-foreground mb-4">
        All plans include a 14-day free trial. No credit card required.
      </p>
      <div class="flex justify-center space-x-6 text-sm text-muted-foreground">
        <div class="flex items-center space-x-2">
          <svg
            class="w-4 h-4 text-green-600"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5" />
          </svg>
          <span>Cancel anytime</span>
        </div>
        <div class="flex items-center space-x-2">
          <svg
            class="w-4 h-4 text-green-600"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5" />
          </svg>
          <span>30-day money back guarantee</span>
        </div>
        <div class="flex items-center space-x-2">
          <svg
            class="w-4 h-4 text-green-600"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5" />
          </svg>
          <span>Secure & compliant</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Promotional -->
  <div
    class="flex flex-col items-center justify-center mt-10 mx-auto max-md:mx-2 max-md:px-2 max-w-5xl w-full text-center rounded-2xl py-20 md:py-24 bg-promotion bg-cover bg-center bg-no-repeat">
    <h1 class="text-2xl md:text-3xl font-medium text-white max-w-2xl">
      Empower Your Sales & Marketing with a Next-Gen AI Workforce
    </h1>
    <div
      class="h-[3px] w-32 my-1 bg-gradient-to-l from-transparent to-white"></div>
    <p class="text-sm md:text-base text-white max-w-xl">
      Leverage AI Agents for real-time calling and unified multi-channel
      engagement, optimizing customer interactions at scale.
    </p>
    <a
      href="/auth/sign-up"
      class="px-10 py-3 mt-4 text-sm bg-white hover:scale-105 transition duration-300 rounded-full">
      Get Started
    </a>
  </div>
</section>

<!-- <div class="hidden h-[20rem] items-center justify-center md:flex lg:h-[20rem]">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 300 100"
    xmlns="http://www.w3.org/2000/svg"
    class="select-none">
    <defs>
      <linearGradient
        id="textGradient"
        gradientUnits="userSpaceOnUse"
        cx="50%"
        cy="50%"
        r="25%"></linearGradient>
      <radialGradient
        id="revealMask"
        gradientUnits="userSpaceOnUse"
        r="20%"
        cx="85.3125%"
        cy="14.628906250000002%">
        <stop offset="0%" stop-color="white"></stop>
        <stop offset="100%" stop-color="black"></stop>
      </radialGradient>
      <mask id="textMask">
        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          fill="url(#revealMask)"></rect>
      </mask>
    </defs>
    <text
      x="50%"
      y="50%"
      text-anchor="middle"
      dominant-baseline="middle"
      stroke-width="0.3"
      class="fill-transparent stroke-neutral-800 font-[helvetica] font-bold text-7xl"
      style="opacity: 0">
      B2B-CRM
    </text>
    <text
      x="50%"
      y="50%"
      text-anchor="middle"
      dominant-baseline="middle"
      stroke-width="0.3"
      class="fill-transparent stroke-neutral-800 font-[helvetica] font-bold text-7xl"
      stroke-dashoffset="0"
      stroke-dasharray="1000">
      B2B CRM
    </text>
    <text
      x="50%"
      y="50%"
      text-anchor="middle"
      dominant-baseline="middle"
      stroke="url(#textGradient)"
      stroke-width="0.3"
      mask="url(#textMask)"
      class="fill-transparent font-[helvetica] font-bold text-7xl">
      B2B CRM
    </text>
  </svg>
</div> -->
<footer
  class="flex flex-wrap justify-center lg:justify-between overflow-hidden gap-10 md:gap-20 py-16 px-6 md:px-16 lg:px-24 xl:px-32 text-[13px] text-gray-500 bg-gradient-to-r from-white via-blue-200/60 to-white dark:shadow-background dark:bg-">
  <div class="flex flex-wrap items-start gap-10 md:gap-[60px] xl:gap-[120px]">
    <a href="#">
      <div class="flex items-center space-x-2 mb-6">
        <div
          class="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center shadow-lg">
          <svg
            class="w-5 h-5 text-white"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>
        <span
          class="text-xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
          >B2B CRM</span
        >
      </div>
    </a>
    <div>
      <p class="text-foreground font-semibold">Product</p>
      <ul class="mt-2 space-y-2">
        <li><a href="/" class="hover:text-indigo-600 transition">Home</a></li>
        <li>
          <a href="/" class="hover:text-indigo-600 transition">Features</a>
        </li>
        <li>
          <a href="/" class="hover:text-indigo-600 transition">Pricing</a>
        </li>
        <li>
          <a href="/" class="hover:text-indigo-600 transition">Integrations</a>
        </li>
        <li><a href="/" class="hover:text-indigo-600 transition">API</a></li>
        <li>
          <a href="/" class="hover:text-indigo-600 transition">Support</a>
        </li>
      </ul>
    </div>
    <div>
      <p class="text-foreground font-semibold">Resources</p>
      <ul class="mt-2 space-y-2">
        <li>
          <a href="/" class="hover:text-indigo-600 transition">Company</a>
        </li>
        <li><a href="/" class="hover:text-indigo-600 transition">Blogs</a></li>
        <li>
          <a href="/" class="hover:text-indigo-600 transition">Community</a>
        </li>
        <li>
          <a href="/" class="hover:text-indigo-600 transition"
            >Careers<span
              class="text-xs text-white bg-indigo-600 rounded-md ml-2 px-2 py-1"
              >We’re hiring!</span
            ></a
          >
        </li>
        <li><a href="/" class="hover:text-indigo-600 transition">About</a></li>
      </ul>
    </div>
    <div>
      <p class="text-foreground font-semibold">Legal</p>
      <ul class="mt-2 space-y-2">
        <li>
          <a href="/privacy" class="hover:text-indigo-600 transition"
            >Privacy</a
          >
        </li>
        <li>
          <a href="/terms" class="hover:text-indigo-600 transition">Terms</a>
        </li>
      </ul>
    </div>
  </div>
  <div
    class="flex flex-col max-md:items-center max-md:text-center gap-2 items-end">
    <p class="max-w-60">
      Making every customer feel valued—no matter the size of your audience.
    </p>
    <div class="flex items-center gap-4 mt-3">
      <a
        href="#"
        target="_blank"
        rel="noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-linkedin size-5 hover:text-indigo-500"
          aria-hidden="true">
          <path
            d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
          <rect width="4" height="12" x="2" y="9"></rect>
          <circle cx="4" cy="4" r="2"></circle>
        </svg>
      </a>
      <a href="#" target="_blank" rel="noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-twitter size-5 hover:text-indigo-500"
          aria-hidden="true">
          <path
            d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
        </svg>
      </a>
      <a
        href="#"
        target="_blank"
        rel="noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-youtube size-6 hover:text-indigo-500"
          aria-hidden="true">
          <path
            d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"></path>
          <path d="m10 15 5-3-5-3z"></path>
        </svg>
      </a>
    </div>
    <p class="mt-3 text-center">
      © 2025 <a href="#">B2B CRM</a>
    </p>
  </div>
</footer>
